import type { ReactNode } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { createTranslator } from "next-intl";
import { Button, Divider, Typography } from "@mui/material";
import { useClaims } from "../ClaimsProvider";
import { useSubmittedClaim } from "../hooks";
import { getVisibleReturnLabel } from "../status/returnState";
import { ReturnLabelPanel } from "../components/ReturnLabelPanel";
import content from "../../../content/claims.json";

export const ThankYou = () => {
  const { locale } = useClaims();
  const [searchParams] = useSearchParams();
  const shipInsureId = searchParams.get("shipInsureId");
  const { claim, hasFetched } = useSubmittedClaim(shipInsureId);
  const returnLabel = claim ? getVisibleReturnLabel(claim) : null;

  const t = createTranslator({
    messages: content[locale as keyof typeof content],
    locale,
  });

  if (!hasFetched) {
    return null;
  }

  return (
    <>
      {t.rich(returnLabel ? "thanks.returnLabelBody" : "thanks.body", {
        header: (chunk: ReactNode) => (
          <Typography variant="h3">{chunk}</Typography>
        ),
        text: (chunk: ReactNode) => <Typography paragraph>{chunk}</Typography>,
        hr: () => <Divider sx={{ mt: 4, mb: 4 }} />,
        bold: (chunk: ReactNode) => <b>{chunk}</b>,
      })}
      <ReturnLabelPanel label={returnLabel} t={t} />
      {t.rich("thanks.cta", {
        button: (chunk: ReactNode) => (
          <Button
            sx={{ marginTop: "20px" }}
            component={RouterLink}
            to={`/claims/${shipInsureId}`}
            variant="contained"
            fullWidth
          >
            {chunk}
          </Button>
        ),
      })}
    </>
  );
};
